import React from "react"
import {NO_TYPE_COLOR} from "../value/value-empty"

type Props = {
    field           : any
    option?         : Option    // not passed while the contact has no type
    configOptions?  : any
    className?      : string
    disabled?       : boolean
    onClick?        : callback
    children?       : any       // the popover
}

/**
 * The form value (quick add) - the same color box plus type name as the inline editable, inside the
 * regular form box. Used for both the empty and the filled value.
 */
export default function FieldCrmContactType_FormValue(props: Props) {

    const option = props.option ?? {
        label   : props.field.noValueOptionLabel,
        color   : NO_TYPE_COLOR
    }

    const size = _.get(props.configOptions, 'size', '36')

    const classes = Classes("ui5-field-form-editable dropdown-form not-selectable", 'h-{0}'.f(size), props.className, {
        "is-disabled": props.disabled
    })

    const labelClasses = Classes("txt-truncate m-b-2", {
        "ui5-txt-default"           : !props.disabled,
        "ui5-txt-no-accent-default" : props.disabled
    })

    return (
        <>
            <div className={classes} onClick={props.onClick}>
                {!_.isNil(option.color) &&
                    <div className={Classes("ui5-color-box m-r-8", "gd-c-{0}".f(option.color))}/>}

                {/* m-b-2 lifts the text 1px against the color box - see FieldCrmContactType_Value */}
                <div className={labelClasses}>
                    {option.label}
                </div>
            </div>
            {props.children}
        </>
    )
}
